import { CONFIG } from "../../config";
import {
  IFeatureFlagMap,
  IResolvedFeatureFlag,
} from "../../interfaces/featureFlag.interface";
import {
  getTokenizedAxios,
  getTokenizedAxiosWithoutRefresh,
} from "../../utils/axiosWithTokenGen";

export async function getFeatureFlagsFromServer(): Promise<IFeatureFlagMap> {
  const axios = await getTokenizedAxios();
  return axios
    .get(CONFIG.ADMIN_SERVER.BASE_URL + "/featureFlags")
    .then((res) => res?.data as IFeatureFlagMap);
}

/**
 * Super-Admin-only write. Uses the no-refresh client because the route answers
 * 403 for a valid token without the claim — a refresh-and-retry would sign the
 * operator out instead of surfacing the refusal.
 */
export async function updateFeatureFlagOnServer(params: {
  key: string;
  enabled: boolean;
}): Promise<IResolvedFeatureFlag> {
  const { key, enabled } = params;
  const axios = await getTokenizedAxiosWithoutRefresh();
  return axios
    .put(
      `${CONFIG.ADMIN_SERVER.BASE_URL}/featureFlags/${encodeURIComponent(key)}`,
      { enabled }
    )
    .then((res) => res?.data as IResolvedFeatureFlag);
}
